
class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('ul'),
        };

        if( this.elements.button != null && this.openSelector != null) {
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
 //           this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
        }

        // document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

    }

    onItemClick(event) {
        event.preventDefault();

        // 如果連結有 onclick 事件，就不執行表單提交
        if (event.currentTarget.getAttribute('onclick')) {
            return;
        }

        // 原有的表單提交邏輯（作為備用）
        this.elements.input.value = event.currentTarget.dataset.value;
        this.querySelector('form')?.submit();
    }

    openSelector() {
        if (this.elements.button && this.elements.panel) {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }
    }

    closeSelector(event) {
        if (this.elements.button && this.elements.panel) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }
        }
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[localization-form__select]').length === 0)){
            this.closeSelector(event);
        }
    }
}

customElements.define('localization-form', LocalizationForm);